import { render } from "./PER_ActiveEmployees.vue?vue&type=template&id=527cd5a0&scoped=true&ts=true"
import script from "./PER_ActiveEmployees.vue?vue&type=script&lang=ts"
export * from "./PER_ActiveEmployees.vue?vue&type=script&lang=ts"

import "./PER_ActiveEmployees.vue?vue&type=style&index=0&id=527cd5a0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-527cd5a0"]])

export default __exports__